import Vue from 'vue'

$(() => {
  if (!$('.js-multiple-area-select-modal').length) {
    return
  }

  // memo
  // js-multiple-area-select-modal > モーダル
  // .js-multiple-area-select-modal_open > エリアモーダルを開く
  // .js-multiple-area-select-modal_close > エリアモーダルを閉じる
  // .js-multiple-area-select-modal_value > エリア選択された値を表示するinput
  // .js-multiple-area-select-modal_params > エリア選択された値のhidden input

  const setupComponent = (id) => {

    let valueTag = $(id).closest('.js-multiple-area-select-modal_wrapper').find('div.js-multiple-area-select-modal_value')
    let valueInput = $(id).closest('.js-multiple-area-select-modal_wrapper').find('input.js-multiple-area-select-modal_value')
    let paramsInput = $(id).closest('.js-multiple-area-select-modal_wrapper').find('.js-multiple-area-select-modal_params')
    let errorsText = $(id).closest('.js-multiple-area-select-modal_wrapper').find('.js-multiple-area-select-modal_errors')

    new Vue({
      el: id,
      data: {
        openedRegion: "",
        selectedAreaIds: [],
        datas: $(id).data('data'), 
        rules: $(id).data('rules'), // Validルール
        // option
        maxSelectableCount: $(id).data('max-selectable-count'), // 最大選択可能件数
        withObjectCount: $(id).data('with-object-count') // item件数の表示
      },
      mounted() {
        // max countをセット
        if (!this.maxSelectableCount) {
          this.maxSelectableCount = 30 
        }

        this.openedRegion = this.datas[0].region_name
        let params = paramsInput.val()
        for (let param of params.split(',')) {
          if (param) {
            this.selectedAreaIds.push(parseInt(param))
          }
        }
        this.updateParams()

        $('.js-object-search-form .js-form-clear').on('click', (e) => {
          this.selectedAreaIds = []
          valueInput.val('')
          paramsInput.val('')
        })
      },
      methods: {
        dispIsDisableAllArea(area_group) {
          if (!this.withObjectCount) {
            return false
          }

          let includeSelectableAreaGroup = false
          for (let area of area_group.areas) {
            if (area.object_count > 0) {
              includeSelectableAreaGroup = true
            }
          }
          return !includeSelectableAreaGroup
        },
        dispIsSelectedAllArea(area_group) {
          if (this.dispIsDisableAllArea(area_group)) {
            return false
          }

          for (let area of area_group.areas) {
            if (this.withObjectCount && area.object_count == 0) {
              // チェック扱い
              continue
            }
            if (!this.selectedAreaIds.includes(area.id)) {
              return false
            }
          }
          return true
        },
        dispSelectedCountInRegion(region_name) {
          let count = 0
          for (let data of this.datas) {
            if (data.region_name !== region_name) {
              continue
            }
            for (let area_group of data.area_groups) {
              for (let area of area_group.areas) {
                if (this.selectedAreaIds.includes(area.id)) {
                  count += 1
                }
              }
            }
          }
          return count
        },
        updateParams() {
          // 表示用
          let values = []
          for (let data of this.datas) {
            for (let area_group of data.area_groups) {
              for (let area of area_group.areas) {
                if (this.selectedAreaIds.includes(area.id)) {
                  values.push(area.name)
                }
              }
            }
          }
          if (values.length > 0) {
            valueInput.val(values.join('、'))
            valueTag.html(`<table class="borderless"><tr><td class="pr-3 align-top" style="width:70px"><strong class="text-dark">選択中</strong></td><td>${values.join('　')}</td></tr></table>`)
          } else {
            valueInput.val('')
            valueTag.html('<valueTag class="mc-secondary">エリアが未選択です</valueTag>')
          }

          // パラメータ用
          let params = [] 
          for (let select of this.selectedAreaIds) {
            params.push(select)
          }
          paramsInput.val(params.join(','))

          // エラー用
          const errors = []
          const selectedCount = this.selectedAreaIds.length
          const maxCount = this.maxSelectableCount
          if (selectedCount > maxCount) {
            // 最大選択数チェック
            errors.push(`${maxCount}件以内で選択してください（選択中：${selectedCount}件）`)
          }
          if (!!this.rules && this.rules.includes("presence") && selectedCount === 0) {
            // 必須チェック
            errors.push("少なくとも1件以上選択してください")
          }
          if (errors.length > 0) {
            errorsText.addClass('is-invalid')
            errorsText.html(errors.join('<br>'))
          } else {
            errorsText.removeClass('is-invalid')
            errorsText.html(null)
          }

          // form-validater発火
          $(id).find('input').trigger('change')
        },
        onSelectRegion(regionName) {
          this.openedRegion = regionName
        },
        onSelectAllArea(area_group) {
          if (this.dispIsSelectedAllArea(area_group)) {
            // 既に選択済みの場合はすべてチェック外す
            for (let area of area_group.areas) {
              this.selectedAreaIds.splice(this.selectedAreaIds.indexOf(area.id), 1)
            }
            this.updateParams()
            return
          }

          // 未選択の場合

          for (let area of area_group.areas) {
            if (this.selectedAreaIds.includes(area.id)) {
              // チェック済みはスキップ
            } else if(this.withObjectCount && area.object_count == 0) {
              // 0件のitemはスキップ
            } else {
              // 未チェックは追加
              this.selectedAreaIds.push(area.id)
            }
          }

          // 最後にソート
          this.selectedAreaIds.sort((a,b) => {
              if(a.sort > b.sort) return -1;
              if(a.sort < b.sort) return 1;
              return 0;
          });

          this.updateParams()
        },
        onSelectArea(area) {
          if (this.selectedAreaIds.includes(area.id)) {
            // チェック済みは削除
            this.selectedAreaIds.splice(
              this.selectedAreaIds.indexOf(area.id), 1)
          } else {
            // 未チェックは追加
            this.selectedAreaIds.push(area.id)
            this.selectedAreaIds.sort((a,b) => {
                if(a.sort > b.sort) return -1;
                if(a.sort < b.sort) return 1;
                return 0;
            });
          }

          this.updateParams()
        },
      }
    })
  }

    // モーダル表示イベント
  $(document).on("click", ".js-multiple-area-select-modal_open", function (e) {
    const elem = document.activeElement;
    elem.blur();
    $(e.target).closest('.js-multiple-area-select-modal_wrapper').find('.js-multiple-area-select-modal').modal('show')
  })
  // モーダル閉じるイベント
  $(document).on("click", ".js-multiple-area-select-modal_close", function (e) {
    $(e.target).closest('.js-multiple-area-select-modal_wrapper').find('.js-multiple-area-select-modal').modal('hide')
  })
    
  // 初期化
  $('.js-multiple-area-select-modal').each((i, element) => {
    let id = $(element).attr('id')
    setupComponent('#' + id)
  })
})
